import { EKYCStatus, schemes, zSchema } from "@zeal/common";

export const updatePartnerKYCStatusRequestSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
  kyc_status: zSchema.nativeEnum(EKYCStatus),
});

export type TUpdatePartnerKYCStatusRequest = zSchema.infer<
  typeof updatePartnerKYCStatusRequestSchema
>;

export type TUpdatePartnerKYCStatusResponse = zSchema.infer<
  typeof updatePartnerKYCStatusRequestSchema
>;
